var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3643 5.34793C20.0894 1.82702 17.325 0.551633 15.563 0.500099C15.492 0.498023 15.425 0.528679 15.3776 0.581565L2.97309 14.4156C2.94957 14.4419 2.93185 14.4728 2.92111 14.5064L0.966938 20.6147M20.2474 5.46624L8.01249 19.9603C7.98252 19.9958 7.94325 20.0223 7.89909 20.0367L2.66739 21.746M7.84961 20.0146C7.53756 18.5557 6.1654 15.6856 3.17123 14.9286M1.18361 22.2308L0.829017 22.3466C0.635167 22.41 0.451125 22.2271 0.513265 22.0328L0.586453 21.804M1.18361 22.2308C1.2438 22.2237 1.20864 22.1285 0.586453 21.804M1.18361 22.2308L1.79169 22.0321M0.586453 21.804L0.716206 21.3985M1.79169 22.0321C1.55051 21.8209 0.997749 21.3985 0.716206 21.3985M1.79169 22.0321L2.32912 21.8565M0.716206 21.3985L0.859628 20.9502M2.32912 21.8565C2.00441 21.5883 1.25591 21.0315 0.859628 20.9502M2.32912 21.8565L2.66739 21.746M0.859628 20.9502L0.966938 20.6147M2.66739 21.746C2.48664 21.4743 1.89351 20.8677 0.966938 20.6147",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.4a2215e326305f26ed3e691e75235756.svg";
export { ForwardRef as ReactComponent };